export default __webpack_public_path__ + "static/media/NeueHansKendrick-Regular.a4571028.otf";